export default __webpack_public_path__ + "roller-press.png?c4a93a327e47a15ee387b843c9a65630";